import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from '../../components/ui';

const EVENT = 'lumnos:credits-exhausted';

/** Open this on each blocked send attempt, even after the user dismisses it. */
export function showUpgradePrompt() {
  window.dispatchEvent(new Event(EVENT));
}

export function UpgradePrompt() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const onExhausted = () => setOpen(true);
    window.addEventListener(EVENT, onExhausted);
    return () => window.removeEventListener(EVENT, onExhausted);
  }, []);
  return (
    <Modal open={open} onOpenChange={setOpen} title="You've reached your credit limit" footer={
      <>
        <Button onClick={() => setOpen(false)}>Not now</Button>
        <Button variant="primary" onClick={() => { setOpen(false); navigate('/plans'); }}>View plans & upgrade</Button>
      </>
    }>
      <p>Your session or weekly credit allowance is exhausted. Session credits return in full 5 hours after your first message in the window. The separate weekly allowance resets on Monday (UTC).</p>
      <p>See the available plans and credit options to keep creating.</p>
    </Modal>
  );
}
